import React from 'react'
import ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import './styles.css' // Import your styles

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  loadRootComponent: () => import('app/Root').then(({ Root }) => Root),
  errorBoundary() {
    //Add your error boundary here
    return <></>
  },
})

export const { bootstrap, mount, unmount } = lifecycles
